var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3496 12C19.3496 11.2544 18.7452 10.65 17.9996 10.65L12.6996 10.65L12.6996 5.34998C12.6996 4.6044 12.0952 3.99998 11.3496 3.99998C10.604 3.99998 9.99961 4.6044 9.99961 5.34998L9.99961 10.65L4.69961 10.65C3.95402 10.65 3.34961 11.2544 3.34961 12C3.34961 12.7456 3.95402 13.35 4.69961 13.35L9.99961 13.35L9.99961 18.65C9.99961 19.3956 10.604 20 11.3496 20C12.0952 20 12.6996 19.3956 12.6996 18.65L12.6996 13.35L17.9996 13.35C18.7452 13.35 19.3496 12.7456 19.3496 12Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4690f2602c8d94d458da20bcdf1fcf5f.svg";
export { ForwardRef as ReactComponent };